import constants from 'constants/index'

const typeFormDriverSteps = (typeForm) => {
  return constants.incidents.INCIDENT_MAIN_DRIVER_SELECTED_STEPS[typeForm]
}

export default typeFormDriverSteps
